import { render } from "./ForgetPasswordClient.vue?vue&type=template&id=7466ae14"
import script from "./ForgetPasswordClient.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__